// Studio booking for /pages/book-a-visit (sections/na-book.liquid). Kept out of the section's inline <script>
// because the storefront breaks lines inside inline-script strings that contain HTML tags.
// Puts the booking form into the page body's <div data-na-book></div> (or after the first paragraph).
// Talks to the CRM's public endpoint (NA AI CRM, apps/web/app/api/public/booking/route.ts; only
// www.null-audio.com / null-audio.com may call it):
//   GET  -> { types: [{ type, label, hint, minutes, days: [{ date, weekday, needsConfirm, slots: ["09:30"] }] }] }
//   POST { type, date, time, name, email, phone, note, website } -> { appointment, manageUrl } | { error, message }
// Times are Singapore time. Tuesdays and Saturdays are by appointment: those bookings wait for staff confirmation.
(function () {
  var ENDPOINT = 'https://crm.null-audio.com/api/public/booking';
  var tpl = document.querySelector('[data-na-book-template]');
  if (!tpl) return;
  var slot = document.querySelector('[data-na-book]');
  if (!slot) {
    var first = document.querySelector('.page__content p, .rte p, main p');
    if (!first) return;
    slot = document.createElement('div');
    first.insertAdjacentElement('afterend', slot);
  }
  slot.appendChild(tpl.content.cloneNode(true));

  var app = slot.querySelector('[data-na-book-app]');
  var typesBox = app.querySelector('[data-na-book-types]');
  var whenStep = app.querySelector('[data-na-book-when]');
  var daysBox = app.querySelector('[data-na-book-days]');
  var timesBox = app.querySelector('[data-na-book-times]');
  var confirmNote = app.querySelector('[data-na-book-confirm]');
  var form = app.querySelector('[data-na-book-form]');
  var summary = app.querySelector('[data-na-book-summary]');
  var errorBox = app.querySelector('[data-na-book-error]');
  var submit = app.querySelector('[data-na-book-submit]');

  // UI text: the section's <script data-na-i18n="book"> block (na.book.* in the locale files), English if it is missing.
  // *name* placeholders are filled in by fill().
  var T = {
    contact: 'Please WhatsApp us at +65 8731 5476 or email sales@null-audio.com to book.',
    minutes: '*n* min',
    noTimes: 'No free times right now. *contact*',
    byAppt: 'by appt',
    apptNote: "*weekday*s are by appointment only – we'll confirm your time by email.",
    dateLong: '*weekday*, *day* *month*',
    summary: '*type* · *date* · *time*',
    timeAm: '*time* am',
    timePm: '*time* pm',
    confirm: 'Confirm booking',
    requestTime: 'Request this time',
    doneRequested: 'Request received',
    doneBooked: "You're booked!",
    doneLine: '*type*: *when*',
    requestedBody: "*weekday*s are by appointment only, so a member of our team will confirm this time with you by email shortly. If it doesn't work on our side, we'll suggest the nearest available time.",
    bookedBody: 'A confirmation has been sent to your email. Need to change it? Use the link in that email or simply reply to it.',
    addCalendar: 'Add to Google Calendar',
    manage: 'View, change or cancel',
    nameRequired: 'Please enter your name.',
    emailInvalid: 'Please enter a valid email address.',
    errorGeneric: 'Sorry, something went wrong. *contact*',
    taken: 'Sorry, that time was just taken – please pick another.',
    unreachable: 'Sorry, we could not reach our booking system. *contact*',
    unavailable: 'Online booking is not available right now. *contact*'
  };
  var DAY_KEYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  var MONTH_KEYS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
  ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].forEach(function (n, i) {
    T['weekday_' + DAY_KEYS[i]] = n;
    T['weekdayShort_' + DAY_KEYS[i]] = n.slice(0, 3);
  });
  ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].forEach(function (n, i) { T['month_' + MONTH_KEYS[i]] = n; });
  (function () {
    var src = document.querySelector('script[data-na-i18n="book"]');
    if (!src) return;
    var j;
    try { j = JSON.parse(src.textContent); } catch (e) { return; }
    var ta = document.createElement('textarea');
    for (var k in T) if (typeof j[k] === 'string' && j[k]) { ta.innerHTML = j[k]; T[k] = ta.value; } // undo any HTML escaping from | t
  })();
  function fill(text, vars) {
    for (var k in vars) text = text.split('*' + k + '*').join(String(vars[k]));
    return text;
  }
  var CONTACT = { contact: T.contact };
  var state = { types: [], type: null, date: null, time: null };

  function el(tag, attrs, text) {
    var e = document.createElement(tag);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (text) e.textContent = text;
    return e;
  }
  function day(date) {
    var d = new Date(date + 'T00:00:00Z');
    return {
      weekday: T['weekday_' + DAY_KEYS[d.getUTCDay()]],
      weekdayShort: T['weekdayShort_' + DAY_KEYS[d.getUTCDay()]],
      day: d.getUTCDate(),
      month: T['month_' + MONTH_KEYS[d.getUTCMonth()]]
    };
  }
  function time12(t) {
    var h = Number(t.slice(0, 2));
    return fill(h < 12 ? T.timeAm : T.timePm, { time: (h % 12 === 0 ? 12 : h % 12) + ':' + t.slice(3, 5) });
  }
  function current() {
    for (var i = 0; i < state.types.length; i++) if (state.types[i].type === state.type) return state.types[i];
    return null;
  }
  function currentDay() {
    var t = current();
    if (!t) return null;
    for (var i = 0; i < t.days.length; i++) if (t.days[i].date === state.date) return t.days[i];
    return t.days[0] || null;
  }
  function showError(text) {
    errorBox.textContent = text;
    errorBox.hidden = !text;
  }

  function renderTypes() {
    typesBox.textContent = '';
    state.types.forEach(function (t) {
      var b = el('button', { type: 'button', 'class': 'na-book__type', 'aria-pressed': String(t.type === state.type) });
      b.appendChild(el('strong', {}, t.label));
      b.appendChild(el('span', {}, t.hint));
      b.appendChild(el('span', {}, fill(T.minutes, { n: t.minutes })));
      b.addEventListener('click', function () {
        state.type = t.type;
        state.date = null;
        state.time = null;
        renderTypes();
        renderWhen();
      });
      typesBox.appendChild(b);
    });
  }

  function renderWhen() {
    var t = current();
    whenStep.hidden = !t;
    form.hidden = true;
    daysBox.textContent = '';
    timesBox.textContent = '';
    confirmNote.hidden = true;
    if (!t) return;
    if (!t.days.length) {
      timesBox.appendChild(el('p', {}, fill(T.noTimes, CONTACT)));
      return;
    }
    var d = currentDay();
    t.days.forEach(function (x) {
      var p = day(x.date);
      var b = el('button', { type: 'button', role: 'option', 'class': 'na-book__day', 'aria-selected': String(x.date === d.date) });
      b.appendChild(el('small', {}, p.weekdayShort));
      b.appendChild(el('b', {}, String(p.day)));
      b.appendChild(el('small', {}, p.month));
      if (x.needsConfirm) b.appendChild(el('em', {}, T.byAppt));
      b.addEventListener('click', function () {
        state.date = x.date;
        state.time = null;
        renderWhen();
      });
      daysBox.appendChild(b);
    });
    if (d.needsConfirm) {
      confirmNote.textContent = fill(T.apptNote, { weekday: day(d.date).weekday });
      confirmNote.hidden = false;
    }
    d.slots.forEach(function (s) {
      var b = el('button', { type: 'button', 'class': 'na-book__time', 'aria-pressed': String(s === state.time) }, time12(s));
      b.addEventListener('click', function () {
        state.time = s;
        renderWhen();
      });
      timesBox.appendChild(b);
    });
    if (state.time) {
      var p = day(d.date);
      summary.textContent = fill(T.summary, { type: t.label, date: fill(T.dateLong, { weekday: p.weekday, day: p.day, month: p.month }), time: time12(state.time) });
      submit.textContent = d.needsConfirm ? T.requestTime : T.confirm;
      form.hidden = false;
    }
  }

  function renderDone(r) {
    var a = r.appointment;
    var requested = a.status === 'requested';
    app.textContent = '';
    var box = el('div', { 'class': 'na-book__done', role: 'status' });
    box.appendChild(el('h3', {}, requested ? T.doneRequested : T.doneBooked));
    box.appendChild(el('p', {}, fill(T.doneLine, { type: a.typeLabel, when: a.when })));
    box.appendChild(el('p', {}, requested
      ? fill(T.requestedBody, { weekday: day(a.date).weekday })
      : T.bookedBody));
    var links = el('div', { 'class': 'na-book__links' });
    if (!requested) links.appendChild(el('a', { 'class': 'button button--primary', href: a.googleCalendarUrl, target: '_blank', rel: 'noopener' }, T.addCalendar));
    if (r.manageUrl) links.appendChild(el('a', { 'class': 'button button--secondary', href: r.manageUrl }, T.manage));
    if (links.childNodes.length) box.appendChild(links);
    app.appendChild(box);
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function load(keep) {
    return fetch(ENDPOINT, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, body: j }; }); })
      .then(function (r) {
        if (!r.ok || !r.body.types) throw new Error((r.body && r.body.message) || 'unavailable');
        state.types = r.body.types;
        if (!keep) {
          var want = new URLSearchParams(location.search).get('type');
          state.type = state.types.some(function (t) { return t.type === want; }) ? want : state.types.length === 1 ? state.types[0].type : null;
        }
        renderTypes();
        renderWhen();
      });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var d = currentDay();
    if (!state.type || !d || !state.time) return;
    showError('');
    var data = { type: state.type, date: d.date, time: state.time };
    ['name', 'email', 'phone', 'note', 'website'].forEach(function (k) { data[k] = (form.elements[k].value || '').trim(); });
    if (!data.name) return showError(T.nameRequired);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(data.email)) return showError(T.emailInvalid);
    submit.disabled = true;
    fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) })
      .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, body: j }; }); })
      .then(function (r) {
        if (r.ok) return renderDone(r.body);
        showError((r.body && r.body.message) || fill(T.errorGeneric, CONTACT));
        // The time was taken in the meantime: refresh the free times.
        if (r.body && r.body.error === 'taken') {
          state.time = null;
          return load(true).then(function () {
            confirmNote.textContent = T.taken;
            confirmNote.hidden = false;
          });
        }
      })
      .catch(function () { showError(fill(T.unreachable, CONTACT)); })
      .then(function () { submit.disabled = false; });
  });

  load(false).catch(function () {
    typesBox.textContent = '';
    typesBox.appendChild(el('p', {}, fill(T.unavailable, CONTACT)));
  });
})();
